
import { BookOpen } from "lucide-react";
import { ThemeToggle } from "@/components/theme/ThemeToggle";
import FigmaExportButton from "@/components/figma/FigmaExportButton";

const KinkipediaHeader = () => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        <BookOpen className="w-6 h-6 text-pink-500 mr-2" />
        <h1 className="text-2xl font-bold text-foreground">Kinkipedia</h1>
      </div>
      
      <div className="flex items-center gap-2">
        <FigmaExportButton />
        <ThemeToggle variant="button" />
      </div>
    </div>
  );
};

export default KinkipediaHeader;
